export const ExampleURLMaps = {
  invoice: {
    type: 'image',
    heading: 'Example invoice',
    urls: {
      prod: 'https://petcdnstore.blob.core.windows.net/csp-images/Templates/sample_itemised_invoice.png'
    },
    imgCssClass: 'invoice',
    screenReader: {
      description: `
        An example of an invoice from a veterinary clinic. 
        In includes the clinic's full address, ABN and a tax invoice number. 
        It also includes details about the owner and the pet. 
        There is a list of all of the items that make up the total charge. 
        Each item includes a description, quantity and subtotal amount and the 
        invoice has been stamped as paid with the amount paid and a remaining balance.`,
      label: 'invoice'
    }
  },
  vetNotes: {
    type: 'image',
    heading: 'Example vet consultation notes',
    urls: {
      prod: 'https://petcdnstore.blob.core.windows.net/csp-images/Templates/sample_vet_consultation_notes.png'
    },
    imgCssClass: 'vetNotes',
    screenReader: {
      description: `
        An example of the vet's consultation notes for a visit, or range of visits, to a veterinary clinic. 
        In includes the clinic's full address, ABN and a tax invoice number. 
        It also includes details about the owner and the pet. 
        There is a summary table of the pet's details including species, breed, age, weight and the like. 
        It also includes freeform notes dated per consultation of the vet's observations and assessments.`,
      label: 'vet consultation notes'
    }
  }
};
